export default "__VITE_ASSET__DPLvfnrA__"